import React from 'react';

type propType = {
  width?: number;
  height?: number;
  fill?: string;
};
export const AddIcon = ({ width, height, fill }: propType) => {
  return (
    <svg
      width={width ? width : 18}
      height={height ? height : 18}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
        fill={fill ? fill : 'white'}
      />
    </svg>
  );
};
